import useFooter from '../../application/hooks/useFooter';

import { VisualBox, FloatingBox, DefaultBox } from '../etc/LBox/LBox';
import {
  Button,
  Skeleton,
  CheckboxBottomsheet,
  Popup,
  Description,
  TheFooter,
} from 'oui';

import Observer from '../etc/Observer/Observer';
import TermFullSheet from '../feedback/TermFullSheet/TermFullSheet';
import usePreviewPromotion from '../../application/bloc/usePreviewPromotion';
import { ThemeProvider } from 'oui';
import { blackTheme, redTheme } from 'oui';
import StackingSnackbar from '../component/StackingSnackbar/StackingSnackbar';

const MainButton = ({
  isInactive,
  inactiveButtonName,
  activeButtonName,
  onClick,
}: {
  isInactive: boolean;
  inactiveButtonName: string;
  activeButtonName: string;
  onClick: () => void;
}) => {
  return (
    <Button
      flexible={true}
      configuration={'contained'}
      state={isInactive ? 'disabled' : 'enabled'}
      isDisabled={isInactive}
      onClick={onClick}
      children={isInactive ? inactiveButtonName : activeButtonName}
    />
  );
};

const Promotion = () => {
  const {
    isLoading,

    promo,
    applyPromotion,
    actByPromotionLink,
    isInactiveButton,
    popup,
    floating,

    termAgreeButtonName,
    checkBottomsheet,
    termFullSheet,
    showTermDetail,
  } = usePreviewPromotion();

  const { navigateOvertake, navigateOvertakePrivacy } = useFooter();

  const handleClickBtn = actByPromotionLink;

  const handleClickSubmitBtn = applyPromotion;

  const handleClickTermLabel = showTermDetail;

  return (
    <>
      {/* @ts-ignore */}
      <ThemeProvider theme={redTheme}>
        <StackingSnackbar bottom={120} />
        {isLoading ? (
          <>
            {promo?.sectionList?.map((section: any, idx: number) => {
              if (section.sectionType === 'image') {
                return (
                  <VisualBox key={idx}>
                    <img
                      src={section.imageFileUrl}
                      alt={'promo-1'}
                      style={{ verticalAlign: 'top' }}
                    />
                  </VisualBox>
                );
              } else if (section.sectionType === 'detail') {
                return (
                  <Description
                    key={idx}
                    infoText={''}
                    productOptions={section.detailList.map(
                      (
                        detail: { title: any; content: any },
                        index: number,
                      ) => ({
                        title: detail.title,
                        description: detail.content,
                        key: +index,
                      }),
                    )}
                  />
                );
              } else if (section.sectionType === 'button') {
                return (
                  <div key={idx}>
                    {
                      <DefaultBox>
                        <Observer
                          handleState={(e: any) => floating.setFloating(e)}
                        >
                          <MainButton
                            isInactive={isInactiveButton(
                              section.inactiveButtonYn1,
                              section.inactiveButtonRequirement1,
                            )}
                            onClick={() => {
                              handleClickBtn(
                                section.linkType1,
                                section.redirectionUrl1,
                              );
                            }}
                            inactiveButtonName={section.inactiveButtonName1}
                            activeButtonName={section.activeButtonName1}
                          />
                        </Observer>
                      </DefaultBox>
                    }

                    {section.activeButtonName2 && (
                      <DefaultBox>
                        <MainButton
                          isInactive={isInactiveButton(
                            section.inactiveButtonYn2,
                            section.inactiveButtonRequirement2,
                          )}
                          onClick={() => {
                            handleClickBtn(
                              section.linkType2,
                              section.redirectionUrl2,
                            );
                          }}
                          inactiveButtonName={section.inactiveButtonName2}
                          activeButtonName={section.activeButtonName2}
                        />
                      </DefaultBox>
                    )}

                    {section.floatingButtonYn1 && (
                      <FloatingBox status={floating.isFloating}>
                        <MainButton
                          isInactive={isInactiveButton(
                            section.inactiveButtonYn1,
                            section.inactiveButtonRequirement1,
                          )}
                          onClick={() => {
                            handleClickBtn(
                              section.linkType1,
                              section.redirectionUrl1,
                            );
                          }}
                          inactiveButtonName={section.inactiveButtonName1}
                          activeButtonName={section.floatingButtonName1}
                        />
                      </FloatingBox>
                    )}
                  </div>
                );
              }
            })}

            <TheFooter
              type={'e'}
              titleTypeE={promo.bottomGuideTitle}
              html={promo.bottomGuideContent}
              onClickOvertake={navigateOvertake}
              onClickOvertakePrivacy={navigateOvertakePrivacy}
            />
          </>
        ) : (
          <Skeleton type={'a'} />
        )}

        <CheckboxBottomsheet
          isOpenCheckBottomsheet={checkBottomsheet.isOpen}
          onCloseCheckBottomsheet={checkBottomsheet.close}
          checkboxItems={checkBottomsheet.checkList}
          onClickCheck={checkBottomsheet.checkItem}
          onClickSubmitButton={handleClickSubmitBtn}
          onClickExpand={handleClickTermLabel}
          onClickElementLabel={handleClickTermLabel}
          title={'약관에 동의하시면\n 대출 조회를 도와드릴게요'}
          buttonText={termAgreeButtonName || '동의하고 대출 심사 진행하기'}
          buttonState={checkBottomsheet.isActive ? 'enabled' : 'disabled'}
          buttonIsDisabled={!checkBottomsheet.isActive}
          toast={{
            open: false,
            onClickCloseToast: () => {},
            message: '',
          }}
        />
        <TermFullSheet
          isOpen={termFullSheet.open}
          title={termFullSheet.title}
          path={termFullSheet.path}
          onClickClose={termFullSheet.close}
        />
        <Popup isPopupOpen={popup.open} title={popup.message} />
      </ThemeProvider>
    </>
  );
};

export default Promotion;
